


















import PTextField from '../p-text-field/p-text-field.vue';
import validatable from '../../mixins/validatable/validatable';
import mixins from '../../mixins';

export default mixins(validatable).extend({
  props: {
    value: { type: String, default: undefined },
    // TODO: Solve extension of props properly
    ...((new PTextField()).$options.props),
  },
  methods: {
    formatDisplay(number: string | undefined) {
      return this.$format.phonePretty(number);
    },
    formatValue(number: string | undefined) {
      return this.$format.phoneData(number);
    },
  },
});
